export const shuffleArray = (array) => {
  let newArray = [...array]; // Create a copy of the array
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]]; // Swap elements
  }
  return newArray;
};

// const generateWordsearchGrid = (words, size) => {
//   let localGrid = Array(size)
//     .fill()
//     .map(() => Array(size).fill(""));

//   let localWordLocations = {};

//   const placeWord = (word) => {
//     const len = word.length;
//     let placed = false;
//     let attempts = 0;
//     while (!placed) {
//       const dir = directions[Math.floor(Math.random() * directions.length)];
//       const row = Math.floor(Math.random() * size);
//       const col = Math.floor(Math.random() * size);
//       attempts += 1;

//       if (canPlaceWord(word, row, col, dir)) {
//         for (let i = 0; i < len; i++) {
//           localGrid[row + i * dir[0]][col + i * dir[1]] = word[i];
//         }
//         // console.log({ word, row, col, dir });
//         // console.log(localWordLocations);
//         localWordLocations = {
//           ...localWordLocations,
//           [word]: { row, col, dir, word },
//         };
//         placed = true;
//       }
//       if (attempts > 1000) {
//         setSize(size + 1);
//         return;
//       }
//     }

//     // dispatch(
//     //   setPuzzleAndPuzzleType({
//     //     ...puzzleSlice,
//     //     puzzle: {
//     //       ...puzzle,
//     //       wordLocations: localWordLocations,
//     //     },
//     //   })
//     // );
//   };

//   const canPlaceWord = (word, row, col, dir) => {
//     for (let i = 0; i < word.length; i++) {
//       const newRow = row + i * dir[0];
//       const newCol = col + i * dir[1];

//       if (
//         newRow < 0 ||
//         newRow >= size ||
//         newCol < 0 ||
//         newCol >= size ||
//         (localGrid[newRow][newCol] !== "" &&
//           localGrid[newRow][newCol] !== word[i])
//       ) {
//         return false;
//       }
//     }
//     return true;
//   };

//   words?.forEach((word) => placeWord(word));

//   for (let i = 0; i < size; i++) {
//     for (let j = 0; j < size; j++) {
//       if (localGrid[i][j] === "") {
//         localGrid[i][j] = String.fromCharCode(
//           65 + Math.floor(Math.random() * 26)
//         );
//       }
//     }
//   }

//   return localGrid;
// };
